import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const CHARACTERS_PER_MESSAGE = 160;

// TODO: find a better way to calculate how many SMS characters will be used, might not be the same as these counts
export const fromAnyToMessageTextLength = (value) => {
  const trimmed = fromAnyToTrimmed(value);
  if ('' === trimmed) return 0;

  return [...trimmed].length;
};

export const fromAnyToMessageCount = (value) => Math.ceil(fromAnyToMessageTextLength(value) / CHARACTERS_PER_MESSAGE);

export const fromMessageCountToCharacterCount = (value) => {
  const result = value * CHARACTERS_PER_MESSAGE;
  return Number.isSafeInteger(result) && 0 < result ? result : 0;
};

export const fromAnyToMessageCharacterCount = (value) => {
  const textCount = fromAnyToMessageTextLength(value);
  const characterCount = Math.ceil(textCount / CHARACTERS_PER_MESSAGE) * CHARACTERS_PER_MESSAGE;
  return Number.isSafeInteger(characterCount) && 0 < characterCount ? characterCount : 0;
};
